// extracted by mini-css-extract-plugin
export default {"search_bar":"style_search_bar__bLXFx","profile_btn":"style_profile_btn__Ejp9O"};